export default function StyleButton({ value, selected, onClick }) {
  return (
    <button
      onClick={() => onClick(value)}
      className="flex flex-col items-center"
      title={value}
    >
      <div
        className={`
          w-10 h-10 rounded-full border-2 transition-all duration-200
          ${selected ? "border-black scale-110" : "border-gray-300"}
        `}
        style={{ backgroundColor: value.toLowerCase() }}
      />

      <span
        className={`
          mt-1 text-xs
          ${selected ? "text-black font-medium" : "text-gray-500"}
        `}
      >
        {value}
      </span>
    </button>
  );
}